import { useCallback } from 'react';

/** Sets the sticky bar's height as `--section-card-sticky-top` on its parent, for the headers below. */
export function useStickyBarRef(): (element: HTMLElement | null) => (() => void) | undefined {
    return useCallback((element: HTMLElement | null) => {
        const parent = element?.parentElement;
        if (!element || !parent) {
            return undefined;
        }

        const observer = new ResizeObserver(() => {
            parent.style.setProperty('--section-card-sticky-top', `${element.offsetHeight}px`);
        });
        observer.observe(element);

        return () => {
            observer.disconnect();
            parent.style.removeProperty('--section-card-sticky-top');
        };
    }, []);
}
